"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandlingContext = exports.ExchangeError = void 0;
exports.withErrorHandling = withErrorHandling;
const React = __importStar(require("react"));
class ExchangeError extends Error {
    constructor(message, options = {}) {
        super(message);
        this.status = options.statusCode;
        this.statusCode = options.statusCode;
        this.requestId = options.requestId;
        this.title = options.title;
        this.summary = options.summary;
        if (options.details) {
            this.details = { errors: options.details };
        }
    }
}
exports.ExchangeError = ExchangeError;
/**
 * Utility function for handling errors inside Exchange. Also contains a "retry" mechanism so function can be retried in case of failure.
 *
 * Sample usage:
 *
 * ```jsx
 * import React from 'react';
 * import { ErrorHandlingContext } from '@mulesoft/exchange-react-hooks';
 *
 * const MyComponent = () => {
 *   const handleError = React.useContext(ErrorHandlingContext);
 *
 *   React.useEffect(() => {
 *     async function callService() {
 *       await serviceCall()
 *     };
 *
 *     (async function init() {
 *       try {
 *         await callService()
 *       } catch (error) {
 *         handleError(error, callService);
 *       }
 *     })();
 *   });
 *
 *   return (
 *     <div>My component</div>
 *   );
 * }
 * ```
 *
 * @category Contexts
 */
exports.ErrorHandlingContext = React.createContext((error) => Promise.reject(error));
exports.ErrorHandlingContext.displayName = 'ErrorHandlingContext';
/**
 * @ignore
 */
function withErrorHandling(Component) {
    return function ErrorHandlingComponent(props) {
        return (React.createElement(exports.ErrorHandlingContext.Consumer, null, (errorHandling) => (React.createElement(Component, Object.assign({}, props, { errorHandling: errorHandling })))));
    };
}
